import InfoLayout from "./InfoLayout";

function Offer() {
  return (
    <InfoLayout title="Advertising">
      <p>
        We offer effective and targeted advertising opportunities within the <strong>Tabata Timer</strong> web application. 
        Your video ad will always be displayed between exercise selection and the start of the timer. 
        In addition, advertising messages or banners can also be integrated into the PDF that users can generate after completing a workout.
      </p>

      <h2>Why choose our advertising space?</h2>
      <ul>
        <li>
          <strong>Stronger reach:</strong> The web application is instantly accessible worldwide, without App Store or Google Play restrictions and without waiting for approval.
        </li>
        <li>
          <strong>Effective ad formats:</strong> Unlike mobile apps, the web version allows the use of video ads or PDF ads, increasing user engagement.
        </li>
        <li>
          <strong>Large screens = better visibility:</strong> Your ad won’t get lost on a small display – on monitors, laptops, or TVs it achieves maximum impact.
        </li>
      </ul>

      <h2>Options and Contact</h2>
      <ul>
        <li>Placement of video ads between exercise selection and timer start</li>
        <li>Advertising banner or message in the PDF generated after a workout</li>
        <li>Immediate availability for a global audience</li>
      </ul>

      <p>
        Feel free to contact us for more detailed information about pricing, terms, and advertising placement options.
      </p>

      <p>
        <strong>Email:</strong> <a href="mailto:admin@tabataworkout.online">admin@tabataworkout.online</a>
      </p>
      <p>
        <strong>Provider:</strong> <a href="https://www.tabataworkout.online" target="_blank" rel="noopener noreferrer">www.tabataworkout.online</a>
      </p>
    </InfoLayout>

  );
}

export default Offer;

